import { PublicContentPage, publicPageHeading } from '../../features/public/PublicContentPage';
import { PublicCta } from '../../features/public/PublicCta';
import { seoForPath } from '../../features/public/seoConfig';

export function AboutPage() {
  return (
    <PublicContentPage seo={seoForPath('/about')}>
      {publicPageHeading(
        'About RideMaadi',
        'RideMaadi is a motorcycle riding and group ride app for riders and riding communities who want to plan, coordinate, and complete group rides together.',
      )}
      <div className="space-y-8 text-content">
        <section>
          <h2 className="text-lg font-semibold">What RideMaadi is</h2>
          <p className="mt-2 leading-relaxed text-muted">
            RideMaadi is a motorcycle group riding app that helps riders discover communities, create
            riding groups, organize rides, and stay connected on the road. It is built for the way
            motorcycle groups actually ride — with meeting points, captains, and a shared plan everyone
            can follow.
          </p>
        </section>
        <section>
          <h2 className="text-lg font-semibold">Who it is for</h2>
          <p className="mt-2 leading-relaxed text-muted">
            Individual riders looking for group rides. Riding groups and motorcycle clubs that need to
            organize rides without chat-app chaos. Captains and organizers who want one place to plan
            routes, invite members, and coordinate on ride day.
          </p>
        </section>
        <section>
          <h2 className="text-lg font-semibold">Our mission</h2>
          <p className="mt-2 leading-relaxed text-muted">
            Group motorcycle rides should be safe, organized, and enjoyable. RideMaadi helps riders and
            riding groups plan routes, coordinate meeting points, and stay connected on the road —
            without relying on scattered chat messages and last-minute confusion.
          </p>
        </section>
        <section>
          <h2 className="text-lg font-semibold">Privacy first</h2>
          <p className="mt-2 leading-relaxed text-muted">
            Ride details, rider profiles, and group information are private to authenticated members.
            Public pages on RideMaadi describe the product — your rides and personal data stay within
            the application.
          </p>
        </section>
      </div>
      <div className="mt-12">
        <PublicCta heading="Start riding with RideMaadi" />
      </div>
    </PublicContentPage>
  );
}
